(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const NS = window.NS || {};

  const formatMoney = (cents) => {
    const v = (cents / 100);
    const amount = v % 1 === 0 ? v.toLocaleString('en-IN') : v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (NS.moneyFormat || '₹{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  };
  NS.formatMoney = formatMoney;

  /* ---------- Drawers / overlays ---------- */
  const overlay = document.createElement('div');
  overlay.className = 'overlay';
  document.body.appendChild(overlay);
  const hoist = () => ['MenuDrawer', 'SearchOverlay'].forEach((id) => {
    const all = $$('#' + id);
    if (all.length > 1) all.forEach((el) => { if (el.parentElement === document.body) el.remove(); });
    const el = document.getElementById(id);
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  });
  hoist();
  document.addEventListener('shopify:section:load', () => { hoist(); $$('[data-predictive-search]').forEach((r) => searchHandlers && searchHandlers(r)); });
  let openEl = null;
  const open = (el) => {
    if (!el) return;
    close();
    el.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    openEl = el;
    const f = el.querySelector('input,button,a');
    f && setTimeout(() => f.focus({ preventScroll: true }), 50);
  };
  const close = () => {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openEl = null;
  };
  NS.open = open; NS.close = close;
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open]');
    if (t) { e.preventDefault(); open(document.getElementById(t.dataset.open)); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
  });

  /* ---------- Announcement ---------- */
  $$('[data-announcement]').forEach((root) => {
    const items = $$('.announcement__item', root);
    if (items.length < 2) return;
    let i = 0;
    const show = (n) => { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); };
    let t = setInterval(() => show(i + 1), 4500);
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-dir]');
      if (!b) return;
      clearInterval(t); show(i + Number(b.dataset.dir)); t = setInterval(() => show(i + 1), 4500);
    });
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-slideshow]').forEach((root) => {
    const slides = $$('.hero__slide', root);
    if (slides.length < 2) return;
    let i = 0, t;
    const go = (n) => {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      $$('.hero__dot', root).forEach((d) => d.classList.toggle('is-active', Number(d.dataset.go) === i));
    };
    const auto = () => { clearInterval(t); const s = Number(root.dataset.speed || 6); if (s) t = setInterval(() => go(i + 1), s * 1000); };
    root.addEventListener('click', (e) => { const d = e.target.closest('.hero__dot'); if (d) { go(Number(d.dataset.go)); auto(); } });
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null; });
    auto();
  });

  /* ---------- Scroller arrows ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-scroll]');
    if (!b) return;
    const s = document.getElementById(b.dataset.target);
    s && s.scrollBy({ left: s.clientWidth * 0.9 * Number(b.dataset.scroll), behavior: 'smooth' });
  });

  /* ---------- Cart ---------- */
  const cartSectionId = 'cart-drawer';
  const refreshCart = async (openAfter) => {
    const res = await fetch(`${NS.routes.root.replace(/\/$/, '')}/?sections=${cartSectionId},cart-count`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data[cartSectionId], 'text/html');
    const fresh = html.querySelector('#CartDrawer');
    const cur = document.getElementById('CartDrawer');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    const countHtml = new DOMParser().parseFromString(data['cart-count'], 'text/html');
    const n = countHtml.querySelector('[data-cart-count]')?.textContent.trim() || '0';
    $$('.cart-count').forEach((el) => { el.textContent = n === '0' ? '' : n; el.dataset.count = n; });
    if (openAfter) open(document.getElementById('CartDrawer'));
  };
  NS.refreshCart = refreshCart;

  const addToCart = async (items) => {
    const res = await fetch(NS.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
    await refreshCart(true);
    return json;
  };
  NS.addToCart = addToCart;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.js-atc, form[data-add-to-cart]');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'buy_now') {
      e.preventDefault();
      const fd = new FormData(form);
      const id = fd.get('id'); const q = fd.get('quantity') || 1;
      const scope = form.closest('[data-product]');
      const extra = scope && form.id === 'ProductForm' ? $$('[data-addon]:checked', scope).map((i) => `,${i.value}:1`).join('') : '';
      window.location.href = `/cart/${id}:${q}${extra}`;
      return;
    }
    e.preventDefault();
    const btn = form.querySelector('[type=submit]:not([name=buy_now])') || form.querySelector('[type=submit]');
    const label = btn ? btn.innerHTML : '';
    btn && (btn.disabled = true, btn.textContent = 'Adding…');
    const fd = new FormData(form);
    const err = form.querySelector('[data-error]');
    err && (err.hidden = true);
    const scope = form.id === 'ProductForm' ? form.closest('[data-product]') : null;
    const addons = scope ? $$('[data-addon]:checked', scope).map((i) => ({ id: Number(i.value), quantity: 1 })) : [];
    try {
      await addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }, ...addons]);
      btn && (btn.textContent = 'Added ✓');
      setTimeout(() => { if (btn) { btn.innerHTML = label; btn.disabled = false; } }, 1600);
    } catch (ex) {
      if (btn) { btn.innerHTML = label; btn.disabled = false; }
      if (err) { err.textContent = ex.message; err.hidden = false; } else alert(ex.message);
    }
  });

  const changeLine = async (line, quantity) => {
    const drawer = document.getElementById('CartDrawer');
    drawer && (drawer.style.opacity = '.6');
    await fetch(NS.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    await refreshCart(false);
    if (document.body.classList.contains('template-cart')) location.reload();
    drawer && (drawer.style.opacity = '');
  };
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (q && q.dataset.line) {
      e.preventDefault();
      const cur = Number(q.dataset.current);
      changeLine(Number(q.dataset.line), Math.max(0, cur + Number(q.dataset.qtyChange)));
      return;
    }
    if (q) {
      e.preventDefault();
      const input = q.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) + Number(q.dataset.qtyChange));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(Number(rm.dataset.removeLine), 0); return; }
    const up = e.target.closest('[data-quick-add]');
    if (up) {
      e.preventDefault();
      up.disabled = true; up.textContent = 'Adding…';
      try { await addToCart([{ id: Number(up.dataset.quickAdd), quantity: 1 }]); } catch (ex) { alert(ex.message); up.disabled = false; up.textContent = '+ Add'; }
    }
  });

  /* Coupon in cart drawer: apply via /discount/CODE then return */
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-apply-code]');
    if (!c) return;
    e.preventDefault();
    const form = c.closest('[data-coupon]');
    const input = form ? form.querySelector('input') : null;
    const code = (c.dataset.applyCode || (input && input.value) || '').trim().toUpperCase();
    if (!code) { input && input.focus(); return; }
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
  });

  /* Copy offer code */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-copy]');
    if (!b) return;
    navigator.clipboard && navigator.clipboard.writeText(b.dataset.copy);
    const t = b.textContent; b.textContent = 'Copied'; setTimeout(() => (b.textContent = t), 1500);
  });

  /* ---------- Predictive search ---------- */
  var searchHandlers = (root) => {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    const input = $('input[type=search]', root);
    const results = $('[data-search-results]', root);
    const chips = $('[data-search-chips]', root);
    const pop = root.classList.contains('search-pop') ? root : $('.search-pop', root.parentElement) || root;
    if (!input || !results) return;
    let t;
    const run = async () => {
      const q = input.value.trim();
      chips && (chips.hidden = !!q);
      if (!q) { results.innerHTML = results.dataset.default || ''; return; }
      try {
        const res = await fetch(`${NS.routes.search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-predictive]');
        results.innerHTML = inner ? inner.innerHTML : '';
      } catch (ex) { /* ignore */ }
    };
    results.dataset.default = results.innerHTML;
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 220); });
    root.addEventListener('click', (e) => {
      const c = e.target.closest('[data-search-term]');
      if (c) { e.preventDefault(); input.value = c.dataset.searchTerm; run(); input.focus(); }
    });
  };
  $$('[data-predictive-search]').forEach(searchHandlers);
  const deskSearch = $('.header__search');
  if (deskSearch) {
    const pop = $('.search-pop', deskSearch);
    const inp = $('input', deskSearch);
    inp.addEventListener('focus', () => pop.classList.add('is-open'));
    document.addEventListener('click', (e) => { if (!deskSearch.contains(e.target)) pop.classList.remove('is-open'); });
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-search]');
    if (!t) return;
    e.preventDefault();
    const ov = document.getElementById('SearchOverlay');
    ov.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('input', ov).focus(), 50);
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-close-search]')) return;
    document.getElementById('SearchOverlay').classList.remove('is-open'); document.documentElement.style.overflow = '';
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const variants = JSON.parse($('[data-variants]', root)?.textContent || '[]');
    const form = $('form.js-atc, form[data-add-to-cart]', root);
    const idInput = form && $('input[name=id]', form);
    const priceNow = $$('[data-price-now]');
    const priceWas = $$('[data-price-was]');
    const save = $$('[data-price-save]');
    const variantLabel = $$('[data-variant-label]');
    const atcBtns = $$('[data-atc]');

    // Gallery
    const slides = $$('.gallery__slide', root);
    const thumbs = $$('.gallery__thumb', root);
    const showSlide = (i) => {
      slides.forEach((s, j) => { s.classList.toggle('is-active', j === i); const v = s.querySelector('video'); if (v && j !== i) v.pause(); });
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => showSlide(i)));
    const main = $('.gallery__main', root);
    if (main && matchMedia('(hover:hover) and (min-width:1024px)').matches) {
      main.addEventListener('mousemove', (e) => {
        const img = $('.gallery__slide.is-active img', main);
        if (!img) return;
        const r = main.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        img.style.transform = 'scale(2)';
      });
      main.addEventListener('mouseleave', () => { const img = $('.gallery__slide.is-active img', main); if (img) img.style.transform = ''; });
    }
    let sx = null;
    main && main.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    main && main.addEventListener('touchend', (e) => {
      if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) < 40) return;
      const cur = slides.findIndex((s) => s.classList.contains('is-active'));
      showSlide((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
    });

    // Variants
    const update = () => {
      const opts = $$('.variant-picker', root).map((fs) => ($('input:checked', fs) || {}).value);
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      idInput && (idInput.value = v.id);
      $$('input[name=id]', document).forEach((i) => { if (i.closest('[data-sticky-atc]')) i.value = v.id; });
      priceNow.forEach((el) => (el.textContent = formatMoney(v.price)));
      priceWas.forEach((el) => { el.hidden = !(v.compare_at_price > v.price); el.textContent = formatMoney(v.compare_at_price || 0); });
      save.forEach((el) => { const off = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0; el.hidden = !off; el.textContent = off + '% OFF'; });
      variantLabel.forEach((el) => (el.textContent = v.title));
      atcBtns.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? 'Add to Cart' : 'Sold out'; });
      if (v.featured_media) {
        const i = slides.findIndex((s) => Number(s.dataset.mediaId) === v.featured_media.id);
        if (i > -1) showSlide(i);
      }
      root.dispatchEvent(new CustomEvent('ns:variant', { detail: v }));
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('.variant-picker input', root).forEach((i) => i.addEventListener('change', update));

    // Quantity breaks
    const qtyInput = form && $('input[name=quantity]', form);
    $$('[data-qb-input]', root).forEach((r) => r.addEventListener('change', () => { if (qtyInput && r.checked) qtyInput.value = r.value; }));
    const firstQb = $('[data-qb-input]:checked', root); if (firstQb && qtyInput) qtyInput.value = firstQb.value;
    root.addEventListener('ns:variant', (e) => {
      const v = e.detail;
      $$('[data-qb-tier]', root).forEach((t) => {
        const q = Number(t.dataset.qty), pct = Number(t.dataset.pct);
        const now = Math.round(v.price * q * (100 - pct) / 100);
        const was = Math.max(v.compare_at_price || 0, v.price) * q;
        $('[data-qb-now]', t).textContent = formatMoney(now);
        $('[data-qb-was]', t).textContent = was > now ? formatMoney(was) : '';
        const sv = $('[data-qb-save]', t); if (sv) { sv.hidden = !(was > now); sv.textContent = 'Save ' + formatMoney(was - now); }
      });
    });

    // Dispatch countdown (IST)
    $$('[data-dispatch]', root).forEach((el) => {
      const txt = $('[data-dispatch-text]', el), cut = Number(el.dataset.cutoff || 14), noSun = el.dataset.sunday === 'true';
      const tick = () => {
        const n = new Date(); const ist = new Date(n.getTime() + (n.getTimezoneOffset() + 330) * 60000);
        const day = ist.getDay(); const mins = ist.getHours() * 60 + ist.getMinutes();
        if ((noSun && day === 0) || mins >= cut * 60) {
          const tomorrowSun = noSun && (day === 6 || (day === 0 && false));
          txt.innerHTML = 'Order now, ships <b>' + ((noSun && day === 6 && mins >= cut * 60) || (noSun && day === 0) ? 'Monday' : 'tomorrow') + '</b>';
        } else {
          const left = cut * 60 - mins; const h = Math.floor(left / 60), m = left % 60;
          txt.innerHTML = 'Order within <b>' + (h ? h + 'h ' : '') + m + 'm</b> for <b>same-day dispatch</b>';
        }
      };
      tick(); setInterval(tick, 30000);
    });

    // Recently viewed: record
    try {
      const h = root.dataset.handle;
      if (h) { const list = JSON.parse(localStorage.getItem('ns_recent') || '[]').filter((x) => x !== h); list.unshift(h); localStorage.setItem('ns_recent', JSON.stringify(list.slice(0, 12))); }
    } catch (e) {}

    // Sticky ATC
    const sticky = $('[data-sticky-atc]');
    const anchor = $('[data-atc-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(anchor);
    }

    // Pincode (format + ETA; plug a courier API here if needed)
    const pin = $('[data-pincode]', root);
    if (pin) {
      const input = $('input', pin), ok = $('[data-pin-ok]', pin), bad = $('[data-pin-err]', pin), eta = $('[data-pin-eta]', pin), shown = $('[data-pin-value]', pin);
      input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, '').slice(0, 6); ok.hidden = true; bad.hidden = true; });
      $('button', pin).addEventListener('click', () => {
        const v = input.value;
        if (!/^[1-9]\d{5}$/.test(v)) { bad.hidden = false; ok.hidden = true; return; }
        const metro = /^(11|40|56|60|70|50|41|12|20|38)/.test(v);
        const d = new Date(Date.now() + (metro ? 3 : 5) * 864e5);
        eta.textContent = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        shown.textContent = v; ok.hidden = false; bad.hidden = true;
        try { localStorage.setItem('ns_pin', v); } catch (e) {}
      });
      try { const p = localStorage.getItem('ns_pin'); if (p) input.value = p; } catch (e) {}
    }
  });

  /* Frequently bought together */
  NS.initFbt = (scope = document) => $$('[data-fbt]', scope).forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const total = $('[data-fbt-total]', root), was = $('[data-fbt-was]', root), count = $('[data-fbt-count]', root), btn = $('[data-fbt-add]', root);
    const calc = () => {
      const on = $$('input[type=checkbox]:checked', root);
      const sum = on.reduce((a, i) => a + Number(i.dataset.price), 0);
      const mrp = on.reduce((a, i) => a + Number(i.dataset.compare || i.dataset.price), 0);
      total.textContent = formatMoney(sum); was.textContent = mrp > sum ? formatMoney(mrp) : '';
      count.textContent = on.length; btn.disabled = !on.length; btn.textContent = `Add ${on.length} to bag`;
    };
    root.addEventListener('change', calc); calc();
    btn.addEventListener('click', async () => {
      const items = $$('input[type=checkbox]:checked', root).map((i) => ({ id: Number(i.value), quantity: 1 }));
      btn.disabled = true; btn.textContent = 'Adding…';
      try { await addToCart(items); btn.textContent = 'Added to bag ✓'; } catch (ex) { alert(ex.message); calc(); }
    });
  });
  try { NS.initFbt(); } catch (e) { console.warn(e); }

  /* Bundle add (home combo section) */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-bundle-add]');
    if (!b) return;
    e.preventDefault();
    const ids = b.dataset.bundleAdd.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    const t = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    try { await addToCart(ids); b.textContent = 'Added to bag ✓'; } catch (ex) { alert(ex.message); b.textContent = t; b.disabled = false; }
  });

  /* ---------- Collection filters (AJAX) ---------- */
  const facetForms = $$('form[data-facets]');
  const applyFacets = async (url) => {
    const grid = document.getElementById('CollectionResults');
    if (!grid) { location.href = url; return; }
    grid.style.opacity = '.5';
    const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + grid.dataset.section);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    ['CollectionResults', 'FacetsDesktop', 'FacetsMobile', 'FilterCount', 'SortSheetBody'].forEach((id) => {
      const fresh = doc.getElementById(id), cur = document.getElementById(id);
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    });
    grid.style.opacity = '';
    history.replaceState({}, '', url);
  };
  const formUrl = (form) => {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of [...params]) if (v === '') params.delete(k);
    return location.pathname + '?' + params.toString();
  };
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-facets]');
    if (!f || f.dataset.live === 'false') return;
    applyFacets(formUrl(f));
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-facets]');
    if (!f) return;
    e.preventDefault(); applyFacets(formUrl(f)); close();
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-facet-link]');
    if (!a) return;
    e.preventDefault(); applyFacets(a.getAttribute('href')); close();
  });
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-sort]');
    if (!s) return;
    const url = new URL(location.href); url.searchParams.set('sort_by', s.value); applyFacets(url.pathname + url.search);
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-load-more]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true; b.textContent = 'Loading…';
    const res = await fetch(b.dataset.loadMore);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const items = doc.querySelectorAll('#ProductGrid > *');
    const grid = document.getElementById('ProductGrid');
    items.forEach((i) => grid.appendChild(i));
    const nextWrap = doc.querySelector('[data-load-more-wrap]');
    const cur = document.querySelector('[data-load-more-wrap]');
    if (nextWrap && cur) cur.innerHTML = nextWrap.innerHTML;
  });

  /* ---------- Recently viewed ---------- */
  $$('[data-recent]').forEach(async (sec) => {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('ns_recent') || '[]'); } catch (e) {}
    list = list.filter((h) => h !== sec.dataset.exclude).slice(0, Number(sec.dataset.limit || 4));
    if (!list.length) return;
    const wrap = $('[data-recent-list]', sec);
    const res = await Promise.all(list.map((h) => fetch(`${NS.routes.root.replace(/\/$/, '')}/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const cards = res.filter(Boolean).map((p) => {
      const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=600' : '';
      const off = p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
      return `<div><div class="card"><a class="card__media" href="${p.url}">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}${off ? `<span class="card__badges"><span class="badge badge--sale">${off}% OFF</span></span>` : ''}</a><div class="card__body"><a class="card__title" href="${p.url}">${esc(p.title)}</a><div class="price"><span class="price__now">${formatMoney(p.price)}</span>${off ? `<s class="price__was">${formatMoney(p.compare_at_price)}</s>` : ''}</div></div></div></div>`;
    });
    if (!cards.length) return;
    wrap.innerHTML = cards.join(''); sec.hidden = false;
  });

  /* ---------- Countdown banner ---------- */
  $$('[data-countdown]').forEach((el) => {
    const raw = (el.dataset.countdown || '').trim();
    const end = new Date(raw.replace(' ', 'T') + (raw.length <= 16 ? ':00' : '') + '+05:30').getTime();
    if (isNaN(end)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { if (!window.Shopify || !Shopify.designMode) el.closest('.shopify-section').hidden = true; clearInterval(t); return; }
      $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
      $('[data-h]', el).textContent = pad(Math.floor((s % 86400) / 3600));
      $('[data-m]', el).textContent = pad(Math.floor((s % 3600) / 60));
      $('[data-s]', el).textContent = pad(s % 60);
    };
    const t = setInterval(tick, 1000); tick();
  });

  /* ---------- Shoppable videos: play when visible ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { const v = en.target; if (en.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else v.pause(); }), { threshold: 0.4 });
    $$('[data-reels] video').forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  }

  /* ---------- Promo popup ---------- */
  $$('[data-popup]').forEach((pop) => {
    const key = 'ns_popup_seen', days = Number(pop.dataset.days || 7);
    let seen = 0; try { seen = Number(localStorage.getItem(key) || 0); } catch (e) {}
    const design = window.Shopify && Shopify.designMode;
    if (!design && seen && Date.now() - seen < days * 864e5) return;
    let done = false;
    const show = () => { if (done || document.documentElement.style.overflow === 'hidden') return; done = true; pop.hidden = false; requestAnimationFrame(() => pop.classList.add('is-open')); try { localStorage.setItem(key, String(Date.now())); } catch (e) {} };
    const hide = () => { pop.classList.remove('is-open'); setTimeout(() => (pop.hidden = true), 250); };
    pop.addEventListener('click', (e) => { if (e.target.closest('[data-popup-close]')) hide(); });
    document.addEventListener('keydown', (e) => e.key === 'Escape' && hide());
    if (design) { document.addEventListener('shopify:section:select', (e) => { if (pop.closest('.shopify-section') && e.target.contains(pop)) { done = false; show(); } }); return; }
    setTimeout(show, Number(pop.dataset.delay || 12) * 1000);
    if (pop.dataset.exit === 'true' && matchMedia('(hover:hover)').matches) document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 8) show(); });
  });

  /* ---------- Scroll reveal ---------- */
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (html.classList.contains('js-anim') && !reduce && 'IntersectionObserver' in window) {
    const SEL = '.section-head,.card,.tile,.concern,.step,.trust__item,.ingredient,.review-card,.value,.bundle__media,.bundle__body,.img-text__media,.img-text__copy,.split__copy,.split__media,.faq-wrap__intro,.accordion>details,.compare,.reel,.newsletter,.footer__top,.footer__col,.footer__brand,.footer__trust,.collection-banner__inner,.contact-card,.contact-wa,.contact__form,.fbt__item,.fbt__total,.product__info>*,.gallery,.ig-grid>a,.logo-strip__item,.countdown__inner';
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    const prep = (scope) => {
      const groups = new Map();
      $(SEL, scope).forEach((el) => {
        if (el.classList.contains('reveal') || el.closest('.drawer,.search-overlay,.popup,.mega,.sticky-atc,.sheet,.hero')) return;
        const p = el.parentElement; const i = groups.get(p) || 0; groups.set(p, i + 1);
        el.style.setProperty('--d', Math.min(i, 6) * 80 + 'ms');
        el.classList.add('reveal'); io.observe(el);
      });
    };
    prep(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && prep(n)))).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  /* ---------- Header state on scroll ---------- */
  const hs = $('.header-section');
  if (hs) { let last = 0; const onS = () => { const y = scrollY; hs.classList.toggle('is-scrolled', y > 8); last = y; }; addEventListener('scroll', onS, { passive: true }); onS(); }

  /* ---------- Newsletter WhatsApp toggle ---------- */
  document.addEventListener('change', (e) => {
    const c = e.target.closest('[data-wa-toggle]');
    if (!c) return;
    const f = c.closest('form').querySelector('[data-wa-field]');
    if (f) f.hidden = !c.checked;
  });
})();
